import { render, staticRenderFns } from "./BehaviourQuestion.vue?vue&type=template&id=af2174bc&scoped=true&"
import script from "./BehaviourQuestion.vue?vue&type=script&lang=js&"
export * from "./BehaviourQuestion.vue?vue&type=script&lang=js&"
import style0 from "./BehaviourQuestion.vue?vue&type=style&index=0&id=af2174bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2174bc",
  null
  
)

export default component.exports